import React, { useEffect, useState } from 'react'
import { Field, Formik, Form } from 'formik'
import * as Yup from 'yup';
import { RenderIf } from "../../../components";
import { FileUpload, TextInput, TextArea, Dropdown } from '../../../components'
import XLoader from "../../../components/common/XLoader";
import { Link, useNavigate } from 'react-router-dom'
import LoggedInUserService from '../../../services/AuthService';
import { toaster } from "../../../utils/toast";
import useAxios from '../../../hooks/useAxios'
import Constants from '../../../Constants'

const Profile = () => {
  const { putData, postData, getData: getUserApiKeys, isLoading: getUserApiKeysIsLoading, } = useAxios()
  const [isAddUserDialogOpened, setIsAddUserDialogOpened] = useState(false);
  const [AddDialog, setAddDialog] = useState(false);
  const [apiKeyArray, setApiKeysArray] = useState([]);

  let navigate = useNavigate();
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    apiKeyName: "",
    apiKey: "",
  })
  const [profilefileName, setprofilefileName] = useState({
    fileName: "",
    imageUrl: null
  });
  useEffect(() => {
    const data = LoggedInUserService.GetLoggedInUserData();
    const imageUrl = data?.profileImageUrl;
    setUser(data)
    getUserApiKeysData();
    setprofilefileName({ imageUrl: imageUrl });
  }, [])

  const getUserApiKeysData = async () => {
    const { success, data, message } = await getUserApiKeys(Constants.ApiUrl.user.getUserApiKeys);
    if (success) {
      setApiKeysArray(data?.apiAccessKeys || [])
    }
  };


  const validationSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Please enter a valid email'),
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
  })

  const onSubmit = (values, setErrors) => {
    const data = LoggedInUserService.GetLoggedInUserData();
    const domain = data.domainName;
    let formData = new FormData();
    formData.append('firstName', values?.firstName)
    formData.append('lastName', values?.lastName)
    formData.append('email', values?.email)
    formData.append('domainName', domain)

    putData(Constants.ApiUrl.user.updateProfile, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      LoggedInUserService.UpdateLoggedInUserSession(res?.token);
    }).catch(err => {

    })

  }

  const openAddDialog = async () => {
    setIsAddUserDialogOpened(true);
    setAddDialog(true)
  }

  const storeApiKeys = (values) => {
    const { apiKeyName, apiKey } = values;

    postData(Constants.ApiUrl.user.storeApiKey, { apiKeyName, apiKey }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      getUserApiKeysData()
      setAddDialog(false)
    }).catch(err => {

    })
  }

  const generateApiKey = (values) => {
    const data={
      clientId: "abcd",
      domain: "http://localhost:5000"
    }
    postData(Constants.ApiUrl.user.generateApiKey, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      setUser({ ...user, apiKeyName:values.apiKeyName, apiKey:res.apiKey})
    }).catch(err => {

    })
  }

  const revokeApiKey=(keyName)=>{
    postData(Constants.ApiUrl.user.revokedApiKey, {keyName}, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      getUserApiKeysData()
      toaster({ message:"Successfully revoked the api key", success:res?.success });
    }).catch(err => {

    })
  }

  return (
    <Formik
      initialValues={{ ...user }}
      validationSchema={validationSchema}
      enableReinitialize={true}
      onSubmit={(values, { setErrors }) => {
        onSubmit(values)
      }}
    >
      {({ errors, touched, isSubmitting, setFieldValue, values }) => {
        return (
          <Form>
            <div className="wrapper add-form">
              <div className="content">
                <div className="title">
                  <h2>Personal Information</h2>
                  <p>Update your photo and personal details here.</p>
                </div>

                <div className="card mb-5">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <Field name="firstName" type="text" removeMargin={true} className="form-control" label="First Name" placeholder="Enter here" component={TextInput} />
                      </div>
                      <div className="form-group">
                        <Field name="lastName" type="text" removeMargin={true} className="form-control" label="Last Name" placeholder="Enter here" component={TextInput} />
                      </div>
                      <div className="form-group">
                        <Field disabled name="email" type="email" removeMargin={true} className="form-control" label="Email Address" placeholder="Enter here" component={TextInput} />
                      </div>
                      <Link className="frgt"
                        to="/forgot-password"
                      >Reset Password?</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="title">
                  <h2>Generate Api Access Key</h2>
                </div>

                <div className="card mb-5">
                  <div className="row">
                    <div className="col-md-6">
                      <button type='button' onClick={() => openAddDialog()} class="btn btn-theme ms-2" style={{ height: '45px', width: '220px' }}>
                        <i class="fa-solid fa-plus me-2"></i> Generate Api Access Key</button>
                    </div>
                  </div>
                  <table class="table table-bordered case-list-table mt-5">
                    <thead>
                      <tr>
                        <th tabindex="0" aria-controls="myTable" rowspan="1" colspan="1">Name</th>
                        <th tabindex="0" aria-controls="myTable" rowspan="1" colspan="1">Key</th>
                        <th tabindex="0" aria-controls="myTable" rowspan="1" colspan="1">Revoke</th>
                      </tr>
                    </thead>
                    <tbody>
                      <RenderIf shouldRender={!getUserApiKeysIsLoading}>
                      {
                        apiKeyArray?.length > 0 && apiKeyArray.map((key,i) => (
                          <tr key={i}>
                            <td>
                              <span>{key.apiKeyName}</span>
                            </td>
                            <td style={{alignItems:'center'}}>
                              <span className='pe-3'>{key.maskedApiKey}</span>
                            </td>
                            <td>
                            <button type='button' onClick={() => revokeApiKey(key.apiKeyName)} class="btn btn-theme ms-2" style={{ height: '40px', width: '80px' }}>
                            Revoke</button>
                            </td>
                          </tr>
                        ))
                      }
                      </RenderIf>
                      {getUserApiKeysIsLoading && <div className='tableLoader'>
                        <XLoader />
                    </div>}
                      
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="content">
                <RenderIf shouldRender={AddDialog}>
                  <div className="modal user-modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Generate Key</h5>
                          <button onClick={() => setAddDialog(false)} type="button" className="close-btn d-flex align-items-center">
                            Close <i className="fa fa-times ms-2" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div className="add-form p-0">
                          <div className="p-4">
                            <div className="row pt-3">
                              <div className="col-12">
                                <div className="form-group">
                                  <Field name="apiKeyName"
                                    label="Key Name"
                                    component={Dropdown}
                                    defaultOption="None"
                                    options={Constants.Dropdowns.apiAccessKeyNames}
                                  />
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="form-group" style={{ position: 'relative' }}>
                                  <button
                                    onClick={() => navigator.clipboard.writeText(values.apiKey)}
                                    type='button'
                                    style={{
                                      position: 'absolute',
                                      right: '8px',
                                      background: 'none',
                                      border: 'none',
                                      cursor: values.apiKey ?  'pointer' : '',
                                      padding: 0,
                                      zIndex: 2,
                                    }}
                                    title="Copy to clipboard"
                                  >
                                    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6 16C5.45 16 4.97917 15.8042 4.5875 15.4125C4.19583 15.0208 4 14.55 4 14V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H15C15.55 0 16.0208 0.195833 16.4125 0.5875C16.8042 0.979167 17 1.45 17 2V14C17 14.55 16.8042 15.0208 16.4125 15.4125C16.0208 15.8042 15.55 16 15 16H6ZM6 14H15V2H6V14ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4H2V18H13V20H2Z" fill={values.apiKey ? '#1277c9' : '#d3d3d3'} />
                                    </svg>
                                  </button>
                                  <Field name="apiKey" placeholder="" label="Key Name" component={TextArea} />
                                </div>
                              </div>
                              <div className="col-12">
                                <button onClick={()=> generateApiKey(values) } type="button" className="btn btn-theme">
                                  Generate Key
                                </button>
                              </div>
                              <div className="modal-footer">
                                <button onClick={() => setAddDialog(false)} type="button" className="btn btn-theme btn-border">
                                  Cancel
                                </button>
                                <button onClick={() => (storeApiKeys(values))} type="button" className="btn btn-theme">
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </RenderIf>
                <div className="btns text-end">
                  <a href="javascript:void(0)" onClick={() => navigate('/cases')} className="btn btn-theme btn-outline me-3">Cancel</a>
                  <button type='submit' className="btn btn-theme">Save Changes</button>
                </div>
              </div>
            </ div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Profile;